import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    mobileBackground: 'bg-white'
  }
} satisfies RecursivePartial<CMSConfig['megaMenu']>
